export default
{
    'Trang chủ': 'Home',
    'Phim Bộ': 'TV Series',
    'Phim Lẻ': 'Movies',
    'Quốc gia': 'Country',
    'Sắp chiếu': 'Upcoming',
    'Ngôn ngữ': 'Language',
    'Tài khoản': 'Account',
    'Hành động': 'Action',
    'Cổ trang': 'Historical',
    'Chiến tranh': 'War',
    'Tình cảm': 'Romance',
    'Hài hước': 'Comedy',
    'Âm nhạc': 'Music',
    'Học đường': 'School',
    'Trung Quốc': 'China',
    'Hàn Quốc': 'South Korea',
    'Nhật Bản': 'Japan',
    'Thái Lan': 'Thailand',
    'Ấn Độ': 'India',
    'Anh': 'UK',
    'Hoạt hình': 'Animation',
    'PHIM ĐỀ CỬ': 'RECOMMENDED MOVIES',
    'PHIM THỊNH HÀNH': 'TRENDING MOVIES',
    'PHIM BỘ': 'TV SERIES',
    'PHIM LẺ': 'MOVIES',
    'PHIM HÀN QUỐC': 'KOREAN MOVIES',
    'PHIM TRUNG QUỐC': 'CHINESE MOVIES',
    'Diễn viên:': 'Cast:',
    'Đạo diễn:': 'Director:',
    'Thể loại': 'Genre',
    'Đánh giá:': 'Rating:',
    'Đề xuất cho bạn!': 'Recommended for you!',
    'Kết quả tìm kiếm cho': 'Search results for',
    'Xem': 'Watch',
    'Chia sẻ': 'Share',
    'Bình luận': 'Comment',
    'Viết bình luận...': 'Write a comment...',
    'Gửi': 'Send',
    'Xem tất cả': 'View all',
    'Năm': 'Year',
    'Đánh giá': 'Rating',
  'Thời lượng': 'Duration',
  'Không có mô tả.': 'No description.',
  'Xem ngay': 'Watch now',
  'Báo lỗi': 'Report error',
  'Xem sau': 'Favorite',
  'Tập ': 'Episode ',
  'Diễn viên': 'Cast',
  'Đạo diễn': 'Director',
  'Thêm bình luận...': 'Add a comment...',
  'Bình luận không được để trống': 'Comment cannot be empty',
  'Phản hồi': 'Reply',
  'Gợi ý cho bạn': 'Suggestions for you',
  'Top phim': 'Top movies',
  'Phim được đề xuất': 'Recommended movies',
  'Dữ liệu đã được gửi tới Admin để xử lý': 'Data has been sent to Admin for processing',
  'Đã sao chép liên kết!': 'Link copied!',
  'Không tìm thấy phim nào với từ khóa': 'No movies found for keyword',
  'Về trang chủ': 'Back to home',
  'Miêu tả': 'Description',
  'Kết quả tìm kiếm: ': 'Search results: ',
  'Đăng ký tài khoản': 'Register account',
  'Điền thông tin bên dưới để tạo tài khoản': 'Fill in the information below to create an account',
  'Tên hiển thị': 'Display name',
  'Mật khẩu': 'Password',
  'Xác nhận mật khẩu': 'Confirm password',
  'Mật khẩu không khớp': 'Passwords do not match',
  'Tôi đồng ý với Điều khoản & Chính sách': 'I agree to the Terms & Policies',
  'Đăng ký': 'Register',
  'Đăng nhập': 'Login',
  'Email không được để trống': 'Email cannot be empty',
  'Email không hợp lệ': 'Invalid email',
  'Đăng ký thành công! Bạn sẽ được chuyển đến trang đăng nhập.': 'Registration successful! You will be redirected to the login page.',
  'Chào mừng bạn quay lại! Vui lòng đăng nhập.': 'Welcome back! Please log in.',
  'Nhập email': 'Enter email',
  'Nhập mật khẩu': 'Enter password',
  'Quên mật khẩu?': 'Forgot password?',
  'Chưa có tài khoản?': 'Don\'t have an account?',
  'Vui lòng nhập đầy đủ email và mật khẩu': 'Please enter both email and password',
  'Đăng nhập thành công': 'Login successful',
  'Đăng nhập thất bại': 'Login failed',
  'Có lỗi xảy ra': 'An error occurred',
  'Tên phim': 'Movie name ...',
  'Không tìm thấy kết quả': 'No results found',
  'Đăng xuất': 'Logout',
  'Đổi giao diện': 'Change theme',
  'Trang xem phim Online với giao diện hiện đại, thân thiện người dùng.': 'Online movie streaming site with a modern, user-friendly interface.',
  'Nguồn phim tổng hợp từ các website lớn với đa dạng thể loại và quốc gia.': 'Movies aggregated from major websites with diverse genres and countries.',
  'Giới thiệu': 'About',
  'Liên hệ': 'Contact',
  'Chính sách quyền riêng tư': 'Privacy Policy',
  'Khiếu nại bản quyền': 'Copyright Complaint',
  'Phim mới': 'New Movies',
  'Phim hay': 'Good Movies',
  'Phim mới chill': 'Chill New Movies',
  'Phim 18': '18+ Movies',
  'Truyện tranh 18': '18+ Comics',
  'Nettruyen': 'Nettruyen',
  'Nettruyen ngôn tình': 'Nettruyen Romance',
  'Hiện đại': 'Modern',
  'Chính kịch': 'Drama',
  'Cổ Trang': 'Historical',
  'Tình Cảm': 'Romance',
  'Hành Động': 'Action',
  'Âu Mỹ': 'Western',
  'Việt Nam': 'Vietnam',
  'TV Show': 'TV Show',

  'Danh sách phim của bạn': 'Your favorite movies',
  'Bạn không có dữ liệu nào được lưu':'You have no saved data',
  'Bạn muốn xem gì?': 'What do you want to watch?',
  'Danh sách phim của bạn!': 'Your favorite movies!',
  'Hết thời gian yêu cầu, vui lòng kiểm tra lại đường truyền internet': 'Request timed out, please check your internet connection',
  '⏳ Hết thời gian chờ. Vui lòng thử lại!': '⏳ Timeout. Please try again!',
  'Lọc':'Filter',
  'Danh sách phim:': 'Movie list:',
  "Không có dữ liệu được hiển thị, vui lòng tải lại trang": "No data to display, please reload the page",
  "Hết thời gian chờ, vui lòng tải lại trang": "Timeout, please reload the page",
  "Thời gian chiếu": "Showtime",
  "Đã lưu": "Saved movies",
  'Bạn không có phim nào đã được lưu': 'You have no saved movies',
'Lịch chiếu':'Schedule',

"BXH HTTQ THỊNH HÀNH": "TRENDING CHARTS",
"Mãn Nhãn với Phim Chiếu Rạp":"Spectacular Theatrical Movies",
  "PHIM VIỆT NAM": "VIETNAMESE MOVIES",
  "PHIM MỚI": "NEW MOVIES",
  "PHIM TÌNH CẢM": "ROMANCE MOVIES",
  "Vừa xong": "Just now",
  "phút trước": "minutes ago",
  "giờ trước": "hours ago",
  "ngày trước": "days ago",
  "Xem từ đầu": "Watch from the beginning",
  "Giới thiệu:": "Introduction:",
  "Thể loại:": "Genre:",
  "Quốc gia:": "Country:",
  "Đang cập nhật": "Updating",
  "Số tập:": "Episodes:",
  "tập": "episodes",
  "Thời lượng:": "Duration:",
  "Tập phim": "Episode",
  "Đề xuất": "Recommended",
  "Xem thêm": "See more",
  "Thu gọn": "Show less",
  "Chưa có bình luận nào. Hãy là người đầu tiên!": "No comments yet. Be the first!",
  "Chưa có dữ liệu của phim này": "No data available for this movie",
  "Vui lòng theo dõi lại sau": "Please check back later",
  "Chủ Nhật": "Sunday",
  "Thứ Hai": "Monday",
  "Thứ Ba": "Tuesday",
  "Thứ Tư": "Wednesday",
  "Thứ Năm": "Thursday",
  "Thứ Sáu": "Friday",
  "Thứ Bảy": "Saturday",
  "Trailer sẽ được phát trước": "Trailer will be played first",
  "Bỏ qua": "Skip",
  "Đăng nhập để bình luận": "Log in to comment",
  "Danh sách tập": "Episode list",
  "Ẩn bộ lọc": "Hide filter",
  "Lọc phim": "Filter movies",
  "Sắp xếp": "Sort",
  "Thuyết Minh": "Voice-over",
  "Lồng Tiếng": "Dubbed",
  "Viễn tưởng": "Sci-Fi",
  "Kinh dị": "Horror",
  "Bí ấn": "Mystery",
  "Phim 18+": "18+ Movies",
  "Tâm lý": "Psychological",
  "Gia đình": "Family",
  "Hồng Kông": "Hong Kong",
  "Pháp": "France",
  "Đức": "Germany",
  "Hà Lan": "Netherlands",
  "Mexico": "Mexico",
  "Thụy điển": "Sweden",
  "Philippines": "Philippines",
  "Châu Phi": "Africa",
  "Đài Loan": "Taiwan",
  "Năm ↓": "Year ↓",
  "Thời gian cập nhật": "Update time",
  "Vui lòng đăng nhập để sử dụng chức năng này": "Please log in to use this feature",
  "Tài khoản của bạn đã hết hạn đăng nhập": "Your login session has expired",
  "Click để xem phim": "Click to watch movie",
  "Tập trước": "Previous episode",
  "Tập tiếp": "Next episode",
  "Xem trailer chính thức": "Watch official trailer",
  "Chiếu rạp": "Theatrical",

  "PHIM HOẠT HÌNH": "ANIMATED MOVIES",
  "Khám phá ngay": "Explore now",
  "Từ khóa nổi bật:": "Top keywords:",
  "Nguồn phim được tổng hợp tự động từ các website lớn với đa dạng thể loại và quốc gia, cập nhật liên tục 24/7.": "Movie sources are automatically aggregated from major websites with diverse genres and countries, updated 24/7.",
  "Kết nối với chúng tôi": "Connect with us",
  "Hỗ trợ":"Support",
  "Chính sách riêng tư":"Privacy Policy",
  "FAQ":"FAQ",
  "Tải ứng dụng":"Download app",
  'Chi tiết': 'Details',
  'Tìm phim...': 'Search movies...',
  'Bạn chưa lưu phim nào':'You have not saved any movies',
  'Hãy khám phá và thêm phim vào danh sách yêu thích':'Explore and add movies to your favorites list',
  'Khám phá phim':'Explore movies',
  'SÔI NỔI NHẤT':'MOST ACTIVE',
  'YÊU THÍCH NHẤT':'MOST FAVORITED',
  'THỂ LOẠI HOT':'HOT GENRES',
  'BÌNH LUẬN MỚI':'NEW COMMENTS',
  'LỊCH CHIẾU PHIM':'RELEASE SCHEDULE',
  'PHIM CHIẾU SỚM':'EARLY SCREENING',
  'Không có phim chiếu sớm':'No early screening movies',
  'phim': 'movies',
  'Giới thiệu về':'About',
  'Nền tảng xem phim trực tuyến hàng đầu dành cho người yêu điện ảnh.':'The leading online movie streaming platform for cinema lovers.',
  'Sứ mệnh của chúng tôi':'Our Mission',
  'ra đời với mong muốn mang đến cho khán giả một không gian giải trí đỉnh cao, nơi bạn có thể thưởng thức những tác phẩm điện ảnh xuất sắc nhất từ khắp nơi trên thế giới. Chúng tôi không ngừng nỗ lực cập nhật các bộ phim bom tấn, phim truyền hình đặc sắc với chất lượng hình ảnh sắc nét và âm thanh sống động nhất.':'was born with the desire to bring audiences a top-notch entertainment space where you can enjoy the best cinematic works from around the world. We constantly strive to update blockbusters and outstanding TV series with the sharpest image quality and most vivid sound.',
  'Điểm nổi bật của Zcines':'Highlights of Zcines',
  'Kho phim khổng lồ':'Massive movie library',
  'Hàng ngàn bộ phim đa dạng thể loại từ hành động, tình cảm, hài hước đến kinh dị, viễn tưởng.':'Thousands of movies of various genres from action, romance, comedy to horror, and sci-fi.',
  'Chất lượng Full HD & 4K': 'Full HD & 4K Quality',
  'Trải nghiệm xem phim mượt mà không giật lag nhờ hệ thống máy chủ mạnh mẽ và tối ưu.':'Smooth, lag-free movie watching experience thanks to a powerful and optimized server system.',
  'Cập nhật nhanh chóng':'Fast updates',
  'Các tập phim mới được đồng bộ liên tục 24/7 ngay sau khi được phát hành chính thức.':'New episodes are continuously synced 24/7 right after their official release.',
  'Liên hệ & Hỗ trợ':'Contact & Support',
  'Danh sách yêu thích':'Favorites List',
  'Zcines luôn luôn lắng nghe mọi ý kiến để cải thiện và mang lại trải nghiệm tuyệt vời nhất cho bạn.':'Zcines always listens to all feedback to improve and bring the best experience to you.',
  'Khám phá phim ngay':'Explore movies now',
  'Miền Tây':'Western',
  'Trẻ Em':'Kids',
  'Lịch Sử': 'History',
  'Tài Liệu': 'Documentary',
  'Thể Thao': 'Sports',
  'Phiêu Lưu': 'Adventure',
  'Âm Nhạc': 'Music',
  'Hình Sự': 'Crime',
  'Võ Thuật': 'Martial Arts',
  'Khoa Học': 'Science',
  'Thần Thoại': 'Mythology',
  'Kinh Điển':'Classic',
  'Phim Ngắn': 'Short Film',
  'Ủng hộ': 'Donate',
  'Ủng hộ chúng tôi': 'Donate to us',
  'Zcines hoàn toàn miễn phí và sẽ luôn như vậy. Mỗi đóng góp của bạn giúp chúng tôi duy trì máy chủ, băng thông và tiếp tục cập nhật phim mỗi ngày.':'Zcines is completely free and always will be. Every contribution helps us keep our servers and bandwidth running, and continue updating movies every day.',
  'Vì sao cần sự ủng hộ của bạn?':'Why do we need your support?',
  'Chi phí vận hành một website xem phim không hề nhỏ: máy chủ, băng thông, subtitle và thời gian của đội ngũ. Quảng cáo chỉ đủ trang trải một phần. Với một ly cà phê từ bạn, chúng tôi có thể tiếp tục mang đến những bộ phim hay nhất hoàn toàn miễn phí cho mọi người.':'Running a movie website is not cheap: servers, bandwidth, subtitles and our team\'s time. Ads only cover part of it. With a cup of coffee from you, we can keep bringing the best movies to everyone, completely free.',
  'Hình thức ủng hộ':'Ways to donate',
  'Sao chép':'Copy',
  'Nội dung chuyển khoản: UNG HO ZCINES. Sau khi chuyển khoản, bạn có thể gửi ảnh chụp biên lai qua Telegram để được xác nhận và cảm ơn.':'Transfer note: UNG HO ZCINES. After transferring, you can send a screenshot of the receipt via Telegram for confirmation and a thank-you.',
  'Lời cảm ơn từ Zcines':'A thank-you from Zcines',
  'Cảm ơn bạn đã đồng hành cùng Zcines. Sự ủng hộ của bạn - dù lớn hay nhỏ - đều là động lực to lớn để chúng tôi tiếp tục phát triển và mang phim hay đến cho cộng đồng.':'Thank you for being with Zcines. Your support - big or small - is a huge motivation for us to keep growing and bringing great movies to the community.',
  'Gửi biên lai qua Telegram':'Send receipt via Telegram',
  'Đã sao chép':'Copied',
  'Không thể sao chép tự động, vui lòng sao chép thủ công':'Could not copy automatically, please copy manually',

}
